import { useState } from 'react';
import { faqItems } from '@/mocks/faq';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <section className="py-12 md:py-16" style={{ backgroundColor: 'oklch(var(--background-50))' }}>
      <div className="section-container max-w-3xl">
        <h2 className="font-heading font-semibold text-xl md:text-2xl text-center mb-2 text-foreground-950">
          Frequently Asked Questions
        </h2>
        <p className="text-sm text-center mb-8 text-foreground-600">
          Everything you need to know about VigorBuy Spreadsheet
        </p>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="rounded-lg overflow-hidden transition-all duration-200"
              style={{
                backgroundColor: 'oklch(var(--background-100))',
                border: '1px solid oklch(var(--background-200))',
              }}
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-heading font-semibold text-sm md:text-base pr-4 text-foreground-900">
                  {item.question}
                </span>
                <div
                  className="w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-transform duration-300"
                  style={{
                    backgroundColor: openIdx === idx ? 'oklch(var(--primary-100))' : 'oklch(var(--background-200))',
                    transform: openIdx === idx ? 'rotate(45deg)' : 'rotate(0deg)',
                  }}
                >
                  <i className="ri-add-line text-sm" style={{ color: openIdx === idx ? 'oklch(var(--primary-600))' : 'oklch(var(--foreground-500))' }}></i>
                </div>
              </button>
              <div
                className="overflow-hidden transition-all duration-300"
                style={{
                  maxHeight: openIdx === idx ? '500px' : '0px',
                }}
              >
                <p className="px-5 pb-4 text-sm leading-relaxed text-foreground-700">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* FAQ Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'FAQPage',
              mainEntity: faqItems.map((item) => ({
                '@type': 'Question',
                name: item.question,
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: item.answer,
                },
              })),
            }),
          }}
        />
      </div>
    </section>
  );
}